import { createSlice } from '@reduxjs/toolkit';
import { MANAGE_SKILL } from '../../actions/ManageSkills/ManageSkillsActionType';

const initialState = {
  manageSkillCycles: {
    isLoading: false,
    assessmentCycles: [],
    data:null,
    errors: '',
    message: ''
  }
};

export const manageSkillCyclesSlice = createSlice({
  name: MANAGE_SKILL,
  initialState,
  reducers: {
    getManageSkillAction: (state) => {
      state.manageSkillCycles.isLoading = true;
      state.manageSkillCycles.errors = '';
    },
    getManageSkillsSuccessAction: (state, action) => {

      if (action.payload) {
        state.manageSkillCycles.assessmentCycles = action.payload;
      
      }
      state.manageSkillCycles.isLoading = false;
    },
    getManageSkillsFailureAction: (state, action) => {
      state.manageSkillCycles.isLoading = false;
      state.manageSkillCycles.errors = action.payload;
    },
 
 
    setSaveSkillsManageAction: (state) => {
      state.manageSkillCycles.isLoading = true;
      state.manageSkillCycles.errors = '';
    },
    setSaveSkillsSuccessAction: (state, action) => {
      state.manageSkillCycles.isLoading = false;
      state.manageSkillCycles.errors = '';
      const p = action.payload;
      if (
        p?.status === 'Success' ||
        (typeof p === 'number' && p >= 1) ||
        p?.data === 1
      ) {
        state.manageSkillCycles.message = 'Saved Successfully!';
      } else {
        state.manageSkillCycles.errors = p?.message || 'Cannot save skill.';
      }
    },
    setSaveSkillsFailureAction: (state, action) => {
      state.manageSkillCycles.isLoading = false;
      state.manageSkillCycles.errors = action.payload;
    },


    deleteManageSkllsAction: (state) => {
      state.manageSkillCycles.isLoading = true;
      state.manageSkillCycles.errors = '';
    },
    deleteManageSkillsSuccessAction: (state, action) => {
      state.manageSkillCycles.isLoading = false;
      state.manageSkillCycles.message = action.payload;
      if (action.payload?.data === 1) {
        state.manageSkillCycles.message = 'Deleted Successfully!';
      } else {
        state.manageSkillCycles.errors = 'Cannot delete. Reference exists!';
      }
    },
    deleteManageSkillsFailureAction: (state, action) => {
      state.manageSkillCycles.isLoading = false;
      state.manageSkillCycles.errors = action.payload;
    },


    getManageSkillsAction: (state) => {
      state.manageSkillCycles.isLoading = true;
      state.manageSkillCycles.errors = '';
    },
    getManageSkillUpdateSuccessAction: (state) => {
      state.manageSkillCycles.isLoading = false;
    },
    getManageSkillUpdateFailureAction: (state, action) => {
      state.manageSkillCycles.isLoading = false;
      state.manageSkillCycles.errors = action.payload;
    },
    resetManageSkillsAction: (state) => {
      state.manageSkillCycles.message = '';
      state.manageSkillCycles.errors = '';
      state.manageSkillCycles.assessmentCycles = null;
    }
  }
});

export const {
    getManageSkillAction,
    getManageSkillsSuccessAction,
    getManageSkillsFailureAction,
    setSaveSkillsSuccessAction,
    setSaveSkillsFailureAction,
    setSaveSkillsManageAction,
    deleteManageSkillsSuccessAction,
    deleteManageSkillsFailureAction,
    deleteManageSkllsAction,
    getManageSkillsAction,
    getManageSkillUpdateSuccessAction,
    getManageSkillUpdateFailureAction,
    resetManageSkillsAction
} = manageSkillCyclesSlice.actions;

export default manageSkillCyclesSlice.reducer;
      